import MoneyBackGuarantee from "../home_page/MoneyGuarantee";
import PricingBox from "../home_page/PricingBox";
import { Box } from "@mui/material";

const Pricing = () => {
  return (
    <>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "black",
          fontSize: "24px",
          boxSizing: "border-box",
          background: "white",
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            width: "100%",
            mt: 5,
            mx: "auto",
            textAlign: "center",
            px: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Box
            component="h1"
            sx={{
              fontSize: { xs: "2rem", sm: "2.4rem" },
              fontWeight: 900,
              color: "#0b1220",
              mb: 1.5,
              lineHeight: 1.15,
            }}
          >
            Simple, Transparent Pricing
          </Box>

          <Box
            component="p"
            sx={{
              fontSize: { xs: "1rem", sm: "1.1rem" },
              fontWeight: 500,
              color: "rgba(0,0,0,0.65)",
              mb: 1,
              maxWidth: 600,
              mx: "auto",
            }}
          >
            One plan. No hidden fees. Transparent data removal with real-time
            progress tracking.
          </Box>
        </Box>

        <PricingBox showHeader={false} backgroundColor="#f6f7fa" />
        <Box sx={{ mb: 5 }}></Box>
      </Box>
      <MoneyBackGuarantee backgroundColor="white" />
    </>
  );
};

export default Pricing;
